import { memo } from "react";

interface CheckBoxProps {
  isChecked?: boolean;
}

export const CheckBox = memo(({ isChecked }: CheckBoxProps) => {
  return <i className={isChecked ? "orange hi-check-circle" : "hi-circle"}></i>;
});
